import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { User, Mail, Phone } from 'lucide-react';

export const ContactInfoSection = ({ formData, onChange }) => (
  <Card className="border-2 border-[#8B7355]/20">
    <CardHeader>
      <CardTitle className="font-serif text-2xl text-[#8B7355]">Contact Information</CardTitle>
    </CardHeader>
    <CardContent className="space-y-4">
      <div>
        <Label htmlFor="name" className="flex items-center gap-2 text-[#8B7355] mb-2">
          <User className="w-4 h-4" /> Full Name *
        </Label>
        <Input
          id="name"
          name="name"
          value={formData.name}
          onChange={onChange}
          required
          className="border-[#8B7355]/30"
          data-testid="booking-name-input"
        />
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="email" className="flex items-center gap-2 text-[#8B7355] mb-2">
            <Mail className="w-4 h-4" /> Email *
          </Label>
          <Input
            id="email"
            name="email"
            type="email"
            value={formData.email}
            onChange={onChange}
            required
            className="border-[#8B7355]/30"
            data-testid="booking-email-input"
          />
        </div>

        <div>
          <Label htmlFor="phone" className="flex items-center gap-2 text-[#8B7355] mb-2">
            <Phone className="w-4 h-4" /> Phone *
          </Label>
          <Input
            id="phone"
            name="phone"
            type="tel"
            value={formData.phone}
            onChange={onChange}
            required
            className="border-[#8B7355]/30"
            data-testid="booking-phone-input"
          />
        </div>
      </div>
    </CardContent>
  </Card>
);
